export const STATUS = Object.freeze({
  IDLE: 'IDLE',
  FAILD: 'FAILD',
  LOADING: 'LOADING',
  SUCCEEDED:'SUCCEEDED'
})

